<template>
  <ut-form :label-width="200">
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> ID
      </template>
      <ut-input placeholder="应用ID" v-model="appId" :style="{width:'500px'}"></ut-input>
      <ut-alert type='warn' :style="{width:'500px'}">
        提示：应用ID为应用的标识,推荐定义为有意义的英文单词,多个单词之间用中划线分隔,如:'apus-message-center';如果目标服务为SpringBoot服务,那么应用ID必须与服务中配置的spring.application.name保持一致
      </ut-alert>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 名称
      </template>
      <ut-input placeholder="应用名称" v-model="appName" :style="{width:'500px'}"></ut-input>
    </ut-form-item>

    <ut-form-item label="* 系统级别">
      <ut-select v-model="selected1" :style="{width:'500px'}">
        <ut-option v-for="item in levelOptions" :value="item.value" :key="item.value" :label="item.label"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 负责人
      </template>
      <ut-select v-model="selected2" multiple filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option v-for="item in selectedSearchUsers||selectedUser" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>
    <ut-form-item label="* 描述" >
      <ut-input :style="{width:'500px'}" type="textarea" placeholder="描述" v-model="description" autosize style="margin-bottom:10px"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <ut-button type="primary" @click="submit">立即创建</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        appId:'',
        appName:'',
        selected1: '',
        selected2: '',
        description: '',
        levelOptions: [
        // {
        //   value: "0",
        //   label: "0级别系统"
        // },
        {
          value: "1",
          label: "1级别系统"
        },
        {
          value: "2",
          label: "2级别系统"
        },
        {
          value: "3",
          label: "3级别系统"
        }
      ],
      selectedSearchUsers:null,
      selectedUser:[]
    }
  },
  methods:{
    submit(){
      var appId = this.appId;
      var appName = this.appName;
      if(appId == ""){
        this.$message.error('应用Id不能为空！');
        return false;
      }
      if(appName == ""){
        this.$message.error('应用名称不能为空！');
        return false;
      }
      if (this.description == "") {
         this.$message.error('描述不能为空！');
        return false;
      }
      if(this.selected1 == ""){
        this.$message.error('系统级别不能为空！');
        return false;
      }
      if(this.selected2 == ""){
        this.$message.error('负责人不能为空！');
        return false;
      }
      var sendData = {};
      sendData.appId = this.appId;
      sendData.appName = this.appName;
      sendData.description = this.description;
      sendData.level = this.selected1;
      sendData.userIds = this.selected2;

      this.$http({
        method: "post",
        url: "apps/add.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('添加成功');
            this.$router.push({ path: "/apps" });
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    goBack(){
      this.$router.push({ path: "/apps" });
    },
    filter (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers = data;
      } else {
        this.selectedSearchUsers = null;
      }
    }
  },
  created() {
    this.$http({
      method: "post",
      url: "users/list.htm",
      data: "{}"
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response); //请求成功返回的数据
        this.selectedUser = response.data;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
  }
}
</script>